import { useGetList } from './useList';

export default function useInventoryMeta() {
  const categories = useGetList('category');

  const category = (c, needle) => {
    const match = categories.get(parseInt(c));

    if (!needle && match) return match;
    if (match) return match.label.toLowerCase().includes(needle.toLowerCase());

    return false;
  }

  const requiresLength = c => {
    const match = category(c);

    return (match && (match.label.toLowerCase().includes('skis') || match.label.toLowerCase().includes('snowboards')));
  }

  return {
    category,
    requiresLength,
    lists: {
      categories: categories,
      accessories: useGetList('accessories'),
      conditions: useGetList('condition'),
      clothingTypes: useGetList('clothing'),
      kidsSizes: useGetList('kids_size'),
      sizes: useGetList('size'),
      bootSizes: useGetList('boot_size'),
      eventType: useGetList('event_type'),
      bootTypeNordic: useGetList('boot_type_nordic'),
      skiTypeNordic: useGetList('ski_type_nordic')
    }
  }
}
